export default "__VITE_ASSET__C3j6jHUX__"